import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/site/Logo";

export default function Login() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password.trim());
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  const FIELD =
    "w-full border-b border-white/20 bg-transparent py-3 text-white placeholder:text-slate-600 outline-none transition-colors duration-300 focus:border-brand-blue";

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-6" data-testid="login-page">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="w-full max-w-sm">
        <Logo />
        <h1 className="mt-10 font-display text-4xl font-medium tracking-tight text-white">Admin access</h1>
        <p className="mt-2 font-mono text-sm uppercase tracking-[0.2em] text-slate-500">Content Management</p>

        <form onSubmit={submit} className="mt-10 space-y-8" data-testid="login-form">
          <div>
            <label className="font-mono text-sm uppercase tracking-[0.2em] text-slate-500">Email</label>
            <input data-testid="login-email" type="email" autoCapitalize="none" autoCorrect="off" autoComplete="username" spellCheck="false" className={FIELD} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Daniel@elevateanalytics.uk" />
          </div>
          <div>
            <label className="font-mono text-sm uppercase tracking-[0.2em] text-slate-500">Password</label>
            <input data-testid="login-password" type="password" autoCapitalize="none" autoCorrect="off" autoComplete="current-password" spellCheck="false" className={FIELD} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="brand-glow-blue w-full bg-brand-blue py-4 font-mono text-sm uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-brand-magenta disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <Link to="/" className="mt-8 inline-block link-underline font-mono text-sm uppercase tracking-[0.2em] text-slate-500">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
